var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 
 * @file Recursively create folder and upload files
 * @author Box
 */
import noop from 'lodash/noop';
import FolderAPI from '../../api/Folder';
import { STATUS_COMPLETE, ERROR_CODE_ITEM_NAME_IN_USE } from '../../constants';
import { getFileFromEntry } from '../../util/uploads';

var FolderUploadNode = function () {

    /**
     * [constructor]
     *
     * @param {string} name
     * @param {Function} addFilesToUploadQueue
     * @param {Function} addFolderToUploadQueue
     * @returns {void}
     */
    function FolderUploadNode(name, addFilesToUploadQueue, addFolderToUploadQueue, fileAPIOptions, baseAPIOptions, entry) {
        _classCallCheck(this, FolderUploadNode);

        _initialiseProps.call(this);

        this.name = name;
        this.addFilesToUploadQueue = addFilesToUploadQueue;
        this.addFolderToUploadQueue = addFolderToUploadQueue;
        this.fileAPIOptions = fileAPIOptions;
        this.baseAPIOptions = baseAPIOptions;
        this.entry = entry;
    }

    /**
     * Upload a folder
     *
     * @public
     * @param {string} parentFolderId
     * @param {Function} errorCallback
     * @param {boolean} isRoot
     * @returns {Promise}
     */


    _createClass(FolderUploadNode, [{
        key: 'upload',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(parentFolderId, errorCallback) {
                var isRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.parentFolderId = parentFolderId;

                                _context.next = 3;
                                return this.createAndUploadFolder(errorCallback, isRoot);

                            case 3:
                                this.addFilesToUploadQueue(this.getFormattedFiles(), noop, true);
                                _context.next = 6;
                                return this.uploadChildFolders(errorCallback);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function upload(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return upload;
        }()

        /**
         * Upload all child folders
         *
         * @private
         * @param {Function} errorCallback
         * @returns {Promise}
         */


        /**
         * Create folder and add it to the upload queue
         *
         * @private
         * @param {Function} errorCallback
         * @param {boolean} isRoot
         * @returns {Promise}
         */


        /**
         * Format files to Array<UploadFileWithAPIOptions> for upload
         *
         * @private
         * @returns {Array<UploadFileWithAPIOptions>}
         */

    }, {
        key: 'createFolder',


        /**
         * Promisify create folder
         *
         * @private
         * @returns {Promise}
         */
        value: function createFolder() {
            var _this = this;

            var folderAPI = new FolderAPI(_extends({}, this.baseAPIOptions, {
                id: 'folder_' + this.parentFolderId
            }));
            return new Promise(function (resolve, reject) {
                folderAPI.create(_this.parentFolderId, _this.name, resolve, reject);
            });
        }

        /**
         * Create FolderUploadNode instances from entries
         *
         * @private
         * @param {Array<FileSystemFileEntry>} entries
         * @returns {Promise<any>}
         */


        /**
         * Recursively read an entry
         *
         * @private
         * @param {DirectoryReader} reader
         * @param {Function} resolve
         * @returns {void}
         */


        /**
         * Build current folder from entry
         *
         * @private
         * @returns {Promise<any>}
         */

    }]);

    return FolderUploadNode;
}();

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.files = [];
    this.folders = {};

    this.uploadChildFolders = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(errorCallback) {
            var folders, promises;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // $FlowFixMe
                            folders = Object.values(_this2.folders);
                            promises = folders.map(function (folder) {
                                return folder.upload(_this2.folderId, errorCallback);
                            });
                            _context2.next = 4;
                            return Promise.all(promises);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x4) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.createAndUploadFolder = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(errorCallback, isRoot) {
            var data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _this2.buildCurrentFolderFromEntry();

                        case 2:
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _this2.createFolder();

                        case 5:
                            data = _context3.sent;

                            _this2.folderId = data.id;
                            _context3.next = 15;
                            break;

                        case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3['catch'](2);

                            if (!(_context3.t0.code !== ERROR_CODE_ITEM_NAME_IN_USE)) {
                                _context3.next = 14;
                                break;
                            }

                            errorCallback(_context3.t0);
                            return _context3.abrupt('return');

                        case 14:

                            _this2.folderId = _context3.t0.context_info.conflicts[0].id;

                        case 15:
                            if (!isRoot) {
                                _context3.next = 17;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 17:

                            _this2.addFolderToUploadQueue([{
                                extension: '',
                                name: _this2.name,
                                status: STATUS_COMPLETE,
                                isFolder: true,
                                size: 1,
                                progress: 100
                            }]);

                        case 18:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[2, 9]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();

    this.getFormattedFiles = function () {
        return _this2.files.map(function (file) {
            return {
                file: file,
                options: _extends({}, _this2.fileAPIOptions, {
                    folderId: _this2.folderId,
                    uploadInitTimestamp: Date.now()
                })
            };
        });
    };

    this.createFolderUploadNodesFromEntries = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(entries) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return Promise.all(entries.map(function () {
                                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(entry) {
                                    var isFile, name, file;
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    isFile = entry.isFile, name = entry.name;

                                                    if (!isFile) {
                                                        _context4.next = 7;
                                                        break;
                                                    }

                                                    _context4.next = 4;
                                                    return getFileFromEntry(entry);

                                                case 4:
                                                    file = _context4.sent;

                                                    _this2.files.push(file);
                                                    return _context4.abrupt('return');

                                                case 7:

                                                    _this2.folders[name] = new FolderUploadNode(name, _this2.addFilesToUploadQueue, _this2.addFolderToUploadQueue, _this2.fileAPIOptions, _extends({}, _this2.baseAPIOptions, _this2.fileAPIOptions), entry);

                                                case 8:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this2);
                                }));

                                return function (_x8) {
                                    return _ref5.apply(this, arguments);
                                };
                            }()));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this2);
        }));

        return function (_x7) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.readEntry = function (reader, resolve) {
        reader.readEntries(function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(entries) {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (entries.length) {
                                    _context6.next = 3;
                                    break;
                                }

                                resolve();
                                return _context6.abrupt('return');

                            case 3:
                                _context6.next = 5;
                                return _this2.createFolderUploadNodesFromEntries(entries);

                            case 5:

                                _this2.readEntry(reader, resolve);

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this2);
            }));

            return function (_x9) {
                return _ref6.apply(this, arguments);
            };
        }(), noop);
    };

    this.buildCurrentFolderFromEntry = function () {
        if (!_this2.entry) {
            return Promise.resolve();
        }

        return new Promise(function (resolve) {
            // $FlowFixMe entry is not empty
            var reader = _this2.entry.createReader();

            _this2.readEntry(reader, resolve);
        });
    };
};

export default FolderUploadNode;